module.exports = __webpack_public_path__ + "img/空白（静态文字）.c93e38da.jpg";